import { defineStore } from "pinia";

import * as paisesApi from "@/services/paises.js";
import * as divisasApi from "@/services/divisas.js";

export const useDivisaListadoStore = defineStore("DivisaListado", {
  state() {
    return {
      // El listado de divisas
      divisas: [],
    };
  },
  actions: {
    async listar(params) {
      this.divisas = await divisasApi.listar(params);
    },
    async eliminar(id) {
      await divisasApi.eliminar(id);
      await this.listar();
    },
  },
});

export const useDivisaStore = defineStore("Divisa", {
  state() {
    return {
      // La divisa que se está editando
      divisa: {},
      // La lista de todos los paises
      paises: [],
      // Los paises seleccionados para la divisa
      paisesSeleccionados: [],
      // Las tasas de conversión de la divisa
      tasas: [],
    };
  },
  getters: {},
  actions: {
    async listar(params) {
      this.divisas = await divisasApi.listar(params);
    },
    cargar(id) {
      this.$reset();
      this.cargarPaises();
      if (id) {
        return divisasApi.cargar(id).then((response) => {
          this.divisa = response.divisa;
          this.paisesSeleccionados = response.paises;
        });
      }
    },
    async guardar() {
      if (this.divisa.id) {
        await divisasApi.actualizar({
          divisa: this.divisa,
          paises: this.paisesSeleccionados,
        });
      } else {
        await divisasApi.insertar({
          divisa: this.divisa,
          paises: this.paisesSeleccionados,
        });
      }
      this.$reset();
    },
    async eliminar() {
      if (this.divisa.id) {
        await divisasApi.eliminar(this.divisa.id);
        this.$reset();
      }
    },
    async cargarPaises() {
      this.paises = await paisesApi.paraCombo();
    },
    setPaisesSeleccionados(ids) {
      this.paisesSeleccionados = ids;
    },
    async cargarTasas(id) {
      this.tasas = await divisasApi.tasasConversion(id);
    },
    async guardarTasa(tasa) {
      tasa.divisaId = this.divisa.id;
      await divisasApi.guardarTasa(tasa);
      await this.cargarTasas(this.divisa.id);
    },
    async eliminarTasa(id) {
      await divisasApi.eliminarTasa(id);
      await this.cargarTasas(this.divisa.id);
    },
  },
});
